<template>
  <v-row>
    <v-col cols="12" class="mt-10">
      <v-col cols="12" class="py-0 ml-auto">
        <v-row>
          <v-col cols="3" class="pt-0">
            <v-select
              dark
              single-line
              hide-details
              color="yellow"
              item-value="id"
              item-text="name"
              label="Aplicativo"
              :items="appsOrdered"
              v-model="searchApp"
              clearable
            >
              <template v-slot:selection="{ item }">
                <v-img
                  v-if="item?.app_photo?.url"
                  :src="item.app_photo.url"
                  max-width="24"
                  max-height="24"
                  class="mr-2"
                ></v-img>
                <div v-else style="width: 32px" class="mr-2">nao tem</div>
                {{ item.name }}
              </template>
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on" dark>
                  <v-list-item-avatar v-if="item?.app_photo?.url" size="32">
                    <v-img :src="item.app_photo.url" title="App"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      :class="attrs.inputValue ? 'primary--text' : ''"
                    >
                      {{ item.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>

          <v-col cols="9" class="pt-0">
            <v-text-field
              dark
              single-line
              hide-details
              color="yellow"
              label="Pesquisar por nome ou descrição..."
              append-icon="mdi-magnify"
              v-model="search"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-data-table
        dark
        class="elevation-2 mt-4"
        :items="filteredProfiles"
        :headers="headers"
        :items-per-page="10"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-if="loadingTable" class="no-hover text-center">
              <td :colspan="headers.length">
                <v-progress-circular
                  :size="50"
                  color="yellow"
                  class="ma-5"
                  indeterminate
                ></v-progress-circular>
              </td>
            </tr>
            <tr class="tr-click" v-for="item in items" :key="item.id">
              <td @click="openModal(item)">{{ item.name }}</td>
              <td @click="openModal(item)">{{ item.description }}</td>
              <td @click="openModal(item)">
                {{ item.app == null ? "Auth" : item.app.name }}
              </td>
              <td @click="openModal(item, true)" style="text-align: center">
                <v-chip>{{ item.users.length }}</v-chip>
              </td>
            </tr>
            <tr
              class="no-hover text-center"
              v-if="!loadingTable && !items.length"
            >
              <td :colspan="headers.length">
                <p class="mt-4">Nenhuma permissão encontrada</p>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-col>
    <v-btn right absolute bottom fab color="yellow" @click="openModal()">
      <v-icon> mdi-plus </v-icon>
    </v-btn>
    <v-dialog
      persistent
      v-model="dialog"
      max-width="500px"
      transition="dialog-bottom-transition"
    >
      <v-card dark style="border: 1px solid #000">
        <v-card-text class="pb-0">
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    label="Nome"
                    color="yellow"
                    :rules="[(v) => !!v || 'O nome é obrigatório']"
                    v-model="name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-0">
                  <v-text-field
                    color="yellow"
                    label="Descrição"
                    v-model="description"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-select
                    color="yellow"
                    item-value="id"
                    item-text="name"
                    label="Aplicativo"
                    :items="appsOrdered"
                    :rules="[(v) => !!v || 'O aplicativo é obrigatório']"
                    v-model="selectedApp"
                  >
                    <template v-slot:selection="{ item }">
                      <v-img
                        v-if="item.app_photo && item.app_photo.url"
                        :src="item.app_photo.url"
                        max-width="24"
                        max-height="24"
                        class="mr-2"
                      ></v-img>
                      {{ item.name }}
                    </template>
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item v-on="on" dark>
                        <v-list-item-avatar
                          v-if="item.app_photo && item.app_photo.url"
                          size="32"
                        >
                          <v-img :src="item.app_photo.url" title="App"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            :class="attrs.inputValue ? 'primary--text' : ''"
                          >
                            {{ item.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
                <v-col class="pa-0">
                  <div v-if="metadata != null">
                    <div class="mb-2">
                      <v-btn
                        text
                        color="red mb-2"
                        x-small
                        @click="metadata = null"
                        >Remover metadata</v-btn
                      >
                    </div>
                    <codemirror v-model="metadata" :options="cmOption" />
                  </div>
                  <v-btn
                    text
                    color="yellow"
                    v-else
                    x-small
                    @click="metadata = ''"
                    >Adicionar metadata</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal()"> Fechar </v-btn>
          <v-btn color="yellow" text @click="save()"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Usuários -->
    <v-dialog
      scrollable
      persistent
      max-width="600"
      transition="dialog-bottom-transition"
      v-model="dialogUsers"
    >
      <v-card dark style="border: 1px solid #000" height="90vh">
        <v-card-title>Usuários ({{ usersSelected.length }})</v-card-title>
        <v-card-text style="height: 300px" class="pa-0">
          <v-text-field
            dense
            hide-details
            solo-inverted
            color="yellow"
            placeholder="Pesquisar"
            class="mt-0 pt-0 rounded-0"
            prepend-inner-icon="mdi-magnify"
            v-model="searchUser"
          ></v-text-field>
          <v-divider></v-divider>
          <v-list class="pa-0" two-line>
            <v-list-item-group v-model="users" multiple active-class="">
              <v-list-item
                v-for="user in usersFiltered"
                :key="user.id"
                :value="user.id"
                @click="changeUser(user.id)"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-avatar class="mr-4">
                    <v-img
                      v-if="user.profile_photo"
                      :src="user.profile_photo.url"
                      title="Foto"
                    ></v-img>
                    <v-img
                      v-else
                      src="@/assets/images/no-photo.jpg"
                      title="Foto"
                    ></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ user.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      user.email
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeModal(true)" :disabled="loading">
            Fechar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="yellow"
            :loading="loading"
            :disabled="loading"
            @click="saveUsers()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import { getApps } from "@/services/apps";
import { getUsers } from "@/services/user";
import { Vue, Component, Watch } from "vue-property-decorator";
import {
  getRoles,
  saveRoles,
  updateRoles,
  updateRolesUsers,
} from "@/services/roles";
import { orderByName } from "@/utils/sort";
import { VAutocomplete } from "vuetify/lib";

@Component
class Permissions extends Vue {
  $refs!: any;
  editId = 0;
  name = "";
  description = "";
  selectedApp = "";
  searchApp: string | (string | null)[] = "";
  search: any = "";
  searchUser: any = "";
  apps: any = [];
  users: any = [];
  allUsers: any = [];
  usersSelected: any = [];
  value = null;
  dialog = false;
  loading = false;
  dialogUsers = false;
  loadingTable = true;
  metadata: any | null = null;
  profiles: any = [];
  cmOption: any = {
    tabSize: 4,
    styleActiveLine: false,
    lineNumbers: true,
    styleSelectedText: false,
    line: true,
    foldGutter: true,
    mode: { name: "text/javascript", json: true },
    hintOptions: {
      completeSingle: false,
    },
    matchBrackets: true,
    showCursorWhenSelecting: true,
    theme: "monokai",
    extraKeys: { Ctrl: "autocomplete" },
  };

  headers = [
    {
      text: "Nome",
      align: "start",
      sortable: false,
      value: "name",
      width: "20%",
    },
    {
      text: "Descrição",
      align: "start",
      sortable: false,
      value: "description",
    },
    {
      text: "Aplicação",
      align: "start",
      sortable: false,
      value: "app",
      width: "15%",
    },
    {
      text: "Usuários",
      align: "center",
      sortable: false,
      value: "profiles",
      width: "15%",
    },
  ];

  get usersFiltered() {
    this.users = this.usersSelected;
    let users = this.allUsers.filter((item: any) => {
      return (
        item.name.toLowerCase().indexOf(this.searchUser.toLowerCase()) > -1
      );
    });
    return users;
  }

  get appsOrdered() {
    return this.apps.sort((a: any, b: any) => {
      let aName: string = a.name;
      let bName: string = b.name;
      return aName.localeCompare(bName, "en");
    });
  }

  get filteredProfiles() {
    const text = (this.search || "").toLowerCase();

    return (this.profiles || []).filter((profile: any) => {
      const name = (profile?.name || "").toLowerCase();
      const description = (profile?.description || "").toLowerCase();

      const matchApp = this.searchApp
        ? profile?.app?.id == this.searchApp
        : true;

      const matchText = text
        ? name.includes(text) || description.includes(text)
        : true;

      return matchApp && matchText;
    });
  }

  async created(): Promise<void> {
    this.searchApp = this.$route?.query?.searchApp || "";
    getUsers()
      .then((res: any) => {
        this.allUsers = res.data;
        this.allUsers = orderByName(this.allUsers);
      })
      .catch((error: any) => {
        console.error(error);
        this.$emit("snackbar", {
          message: "Erro ao carregar os usuários!",
        });
      });
    await getApps()
      .then((res: any) => {
        const apps = res.data;
        apps.map((user: any) => {
          this.apps.push(user);
        });
      })
      .catch((error: any) => {
        console.info(error);
        this.$emit("snackbar", {
          message: "Erro ao carregar os aplicativos!",
        });
      });
    await getRoles(null)
      .then((res: any) => {
        this.profiles = res.data;
      })
      .catch((error: any) => {
        console.info(error);
        this.$emit("snackbar", {
          message: "Erro ao carregar as permissões!",
        });
      });
    this.loadingTable = false;

    if (Object.keys(this.$route.query).length !== 0) {
      let id: any = atob(this.$route.query.id + "");
      this.openModal(
        this.profiles.find((p: any) => p.id == id),
        this.$route.query.isUsers == "true" ? true : false,
      );
    }
  }

  // searchForApp(): {}

  openModal(profile: any = null, isUsers = false): void {
    if (profile != null) {
      this.addfilters(profile.id, isUsers);
      this.editId = profile.id;
      this.name = profile.name;
      this.description = profile.description;
      if (profile.metadata)
        this.metadata = JSON.stringify(profile.metadata, null, 2);
      if (profile.app != null) this.selectedApp = profile.app.id;
      profile.users.forEach((u: any) => this.users.push(u.id + ""));

      if (isUsers) this.usersSelected = [...this.users];
    }
    isUsers ? (this.dialogUsers = true) : (this.dialog = true);
  }

  closeModal(isUsers = false): void {
    if (this.$route.fullPath != this.$route.path) this.setQuery();
    this.editId = 0;
    setTimeout(() => {
      this.name = "";
      this.searchUser = "";
      this.description = "";
      this.selectedApp = "";
      this.users = [];
      this.usersSelected = [];
      if (!isUsers) this.$refs.form.reset();
    }, 290);
    isUsers ? (this.dialogUsers = false) : (this.dialog = false);
  }

  save(): void {
    if (!this.$refs.form.validate()) return;
    if (this.editId != 0) {
      updateRoles(this.editId, {
        name: this.name,
        description: this.description,
        app: this.selectedApp,
        metadata: JSON.parse(this.metadata) || undefined,
      })
        .then(() => {
          this.profiles.find((profile: any) => {
            if (profile.id == this.editId) {
              profile.name = this.name;
              profile.description = this.description;
              profile.app = this.apps.find(
                (a: any) => a.id == this.selectedApp,
              );
            }
          });

          this.closeModal();
          this.$emit("snackbar", {
            message: "Editada com sucesso!",
          });
        })
        .catch((error) => {
          console.error(error);
          this.$emit("snackbar", {
            message: "Erro ao editar!",
          });
        });
    } else {
      saveRoles({
        name: this.name,
        description: this.description,
        app: this.selectedApp,
        metadata: JSON.parse(this.metadata) || undefined,
      })
        .then(() => {
          getRoles(null)
            .then((res: any) => {
              this.profiles = res.data;
            })
            .catch((error: any) => {
              console.info(error);
              this.$emit("snackbar", {
                message: "Erro ao carregar as permissões!",
              });
            })
            .finally(() => {
              this.loadingTable = false;
            });
          this.closeModal();
          this.$emit("snackbar", {
            message: "Criada com sucesso!",
          });
        })
        .catch((error) => {
          console.error(error);
          this.$emit("snackbar", {
            message: "Erro ao criar!",
          });
        });
    }
  }

  saveUsers(): void {
    this.loading = true;
    updateRolesUsers(this.editId, { users: this.users })
      .then(() => {
        this.profiles.find((profile: any) => {
          if (profile.id == this.editId) {
            let newUsers: any = [];
            this.users;
            this.allUsers.forEach((user: any) => {
              if (this.users.indexOf(user.id) != -1) newUsers.push(user);
            });
            profile.users = newUsers;
            this.closeModal(true);
          }
        });
      })
      .catch((error) => {
        console.error(error);
        this.$emit("snackbar", {
          message: "Erro ao editar os usuários!",
        });
      })
      .finally(() => (this.loading = false));
  }

  addfilters(id: any, isUsers: boolean): void {
    if (this.$route.fullPath == this.$route.path) {
      let query: any = {
        id: btoa(id),
        isUsers: isUsers,
      };
      this.setQuery(query);
    }
  }

  setQuery(query: any = {}): void {
    let name: any = this.$route.name;
    this.$router.replace({
      name: name,
      query: query,
    });
  }

  changeUser(id: any): void {
    if (this.usersSelected.indexOf(id) > -1) {
      this.usersSelected.splice(this.usersSelected.indexOf(id), 1);
    } else {
      this.usersSelected.push(id);
    }
  }
}

export default Permissions;
</script>

<style lang="scss" scoped>
.v-list {
  background: #1e1e1e !important;
}
</style>
